import { useCategories } from "../hooks/useCategories.ts";
import { navigate } from "../lib/router.ts";

export function Footer() {
  const { categories } = useCategories();
  const topCategories = categories.slice(0, 8);

  return (
    <footer className="border-t border-border py-6 mt-auto">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="flex items-center justify-between text-xs text-text-muted mb-4">
          <span>open source alternatives directory</span>
          <a href="https://x.com/yashbindal__" target="_blank" rel="noopener noreferrer" className="hover:text-accent transition-colors">@yashbindal__</a>
        </div>

        {topCategories.length > 0 && (
          <nav aria-label="Categories" className="flex flex-wrap gap-x-4 gap-y-1 text-[10px] text-text-muted">
            {topCategories.map((cat) => (
              <a
                key={cat.slug}
                href={`/category/${cat.slug}`}
                onClick={(e) => {
                  e.preventDefault();
                  navigate(`/category/${cat.slug}`);
                }}
                className="hover:text-accent transition-colors"
              >
                {cat.name}
              </a>
            ))}
            <a
              href="/sitemap.xml"
              className="hover:text-accent transition-colors"
            >
              Sitemap
            </a>
          </nav>
        )}
      </div>
    </footer>
  );
}
